/* eslint-disable import/no-cycle */
import {decorate, observable} from 'mobx';
import {get} from 'lodash';
import {Api} from '../middleware/api';
import {EntityStore} from './entityStore';
import {Setting} from '../models/setting';

export class SettingStore extends EntityStore {
  settings = [];

  constructor(rootStore) {
    super(rootStore, 'settings', Api.settings, Setting);
  }

  getByIdentifierAndWorkplace(identifier) {
    return this.settings.find(
      (setting) => setting.identifier === identifier
    );
  }

  getByIdentifier(identifier) {
    return this.settings.find(
      (setting) => setting.identifier === identifier
    );
  }

  getByConfigIds({ids = [], path, identifier}) {
    // TODO: workplaceId is currently not handled
    const found = this.getByIdentifierAndWorkplace(identifier);
    if (!found) {
      return null;
    }

    const result = [];
    ids.forEach((id) => {
      const setting = get(found, [path, id]);
      if (setting) {
        result[id] = setting;
      }
    });

    return result;
  }

  createOrUpdate(terminalLayoutId, workplaceId, identifier, value) {
    // TODO: workplaceId is currently not handled
    const currentSetting = this.getByIdentifierAndWorkplace(identifier);
    if (currentSetting
      && currentSetting.id
      && currentSetting.terminalLayoutId === terminalLayoutId) {
      this.update({id: currentSetting.id, value});
    } else {
      this.create({terminalLayoutId, workplaceId: null, identifier, value});
    }
  }
}

decorate(SettingStore, {
  settings: observable,
});
